import angular from 'angular';
import 'angular-ui-router';
import Rx from 'rx';

export default angular.module('app.services.observables', [
  'ui.router'
])
  .service('currentGame', function(){
    return new Rx.BehaviorSubject(null);
  })
  .service('currentGameDeveloper', function(){
    return new Rx.BehaviorSubject(null);
  })
  .service('currentUser', function(){
    return new Rx.BehaviorSubject(null);
  })
  .service('newCampaign', function(){
    return new Rx.BehaviorSubject(null);
  })
  .service('newGame', function(){
    return new Rx.Subject(null);
  })
  .service('currentExploreGroup', function(){
    return new Rx.BehaviorSubject(null);
  })
  .service('currentExploreGroupForCharts', function(){
    return new Rx.BehaviorSubject(null);
  })
  .service('exploreBenchmarkSnapshotSubject', function(){
    return new Rx.BehaviorSubject(null);
  })
  .service('exploreFilteredSnapshotDataSubject', function(){
    return new Rx.BehaviorSubject(null);
  })
  .service('allVariationsAndCreativesRetrieved', function(){
    return new Rx.BehaviorSubject(null);
  })
  .service('availableSegmentRulesLogicalFields', function(){
    return new Rx.BehaviorSubject(null);
  })



/** WEBPACK FOOTER **
 ** ./src/services/observables.js
 **/